<mat-dialog-content>
  <div style="display: flex; flex-flow: column">
    <h2 mat-dialog-title>Renommer le {{typeDocument}}</h2>
    <div style="display:flex; align-items: center; color:white; background-color: lightblue;margin-bottom:20px;padding: 8px;border-radius: 10px;" *ngIf="error">
      <mat-icon>information</mat-icon><span style="margin-left:8px;">{{error}}</span>
    </div>
    <mat-form-field>
      <input matInput [(ngModel)]="newName" placeholder="Nom du {{typeDocument}}">
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="dialogRef.close()">Annuler</button>
  <button mat-button [disabled]="newName === data.name || !newName" (click)="onSubmit()">Renommer</button>
</mat-dialog-actions>
